export const EVENT_TYPES = [
  { key: "falta", label: "Falta", short: "FAL", color: "#FFFFFF", text: "#000", group: "disc", note: true },
  { key: "amarelo", label: "Cartão Amarelo", short: "CA", color: "#FFCC00", text: "#000", group: "disc", note: true },
  { key: "ca_por_exibir", label: "CA por exibir", short: "CA·PE", color: "#8A6E00", text: "#fff", group: "disc", note: true },
  { key: "vermelho", label: "Cartão Vermelho", short: "CV", color: "#FF3B30", text: "#fff", group: "disc", note: true },
  { key: "cv_por_exibir", label: "CV por exibir", short: "CV·PE", color: "#8B1E18", text: "#fff", group: "disc", note: true },
  { key: "pp", label: "PP", short: "PP", color: "#FF2D92", text: "#fff", group: "disc", note: true },
  { key: "pp_por_assinalar", label: "PP por assinalar", short: "PP·PA", color: "#8E2A5C", text: "#fff", group: "disc", note: true },
  { key: "golo", label: "Golo", short: "GOLO", color: "#34C759", text: "#000", group: "jogo", playersOnly: true, noZone: true },
  { key: "autogolo", label: "Autogolo", short: "AG", color: "#1E7A3A", text: "#fff", group: "jogo", playersOnly: true, noZone: true },
  { key: "substituicao", label: "Substituição", short: "SUB", color: "#5AC8FA", text: "#000", group: "jogo", flow: "sub" },
  { key: "vantagem", label: "Vantagem", short: "VAN", color: "#007AFF", text: "#fff", group: "jogo" },
  { key: "fj_aa1", label: "Fora de Jogo AA1", short: "FJ1", color: "#CCFF00", text: "#000", group: "jogo", zoneOnly: true },
  { key: "fj_aa2", label: "Fora de Jogo AA2", short: "FJ2", color: "#7FD1AE", text: "#000", group: "jogo", zoneOnly: true },
  { key: "assistencia", label: "Assistência", short: "ASS", color: "#E5E5EA", text: "#000", group: "jogo", flow: "direct" },
  { key: "outros", label: "Outros", short: "OUT", color: "#8E8E93", text: "#fff", group: "jogo", note: true },
  { key: "falta_aa1", label: "Falta assinalada por AA1", short: "FA1", color: "#FF9F0A", text: "#000", legacy: true },
  { key: "falta_aa2", label: "Falta assinalada por AA2", short: "FA2", color: "#FF9F0A", text: "#000", legacy: true },
];

export const EVENT_MAP = Object.fromEntries(EVENT_TYPES.map((e) => [e.key, e]));

export const visibleTypes = (m) => EVENT_TYPES.filter((t) => m.events.some((e) => e.type === t.key));

export const formatTime = (secs) => {
  const s = Math.max(0, Math.floor(secs));
  return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
};

export const currentSeconds = (m) =>
  (m?.clock_elapsed || 0) + (m?.clock_started_at ? (Date.now() - Date.parse(m.clock_started_at)) / 1000 : 0);

const HALF = 45 * 60;
const OFFSET = { 1: 0, 2: 45, 3: 90, 4: 105 };
const LIMIT = { 1: 45, 2: 90, 3: 105, 4: 120 };
export const PERIODS = [1, 2, 3, 4];
export const PERIOD_SHORT = { 1: "1ª", 2: "2ª", 3: "P1", 4: "P2" };
export const PERIOD_LABEL = { 1: "1ª parte", 2: "2ª parte", 3: "1ª parte prol.", 4: "2ª parte prol." };
export const isExtraTime = (m) => m.period >= 3 || (m.period === 2 && !!m.halftime_started_at) || m.events.some((e) => e.period >= 3);
// Seconds on a continuous 0-120 scale; `reset` = 2nd half clock restarted at 0 (unknown -> guess)
export const matchClock = (seconds, period, reset) =>
  period >= 3 ? seconds + OFFSET[period] * 60 : period === 2 && (reset ?? seconds < HALF) ? seconds + HALF : seconds;

export const stoppage = (seconds, period, reset) => {
  const extra = Math.floor(matchClock(seconds, period, reset) / 60) + 1 - LIMIT[period];
  return extra > 0 ? extra : 0;
};

export const matchMinute = (seconds, period = 1, reset) => {
  const extra = stoppage(seconds, period, reset);
  return extra ? `${LIMIT[period]}+${extra}'` : `${Math.floor(matchClock(seconds, period, reset) / 60) + 1}'`;
};

export const isCup = (m) => m?.competition === "Taça";
export const eventMinute = (e, reset) =>
  e.halftime ? "Int." : e.phase === "pre_jogo" ? "Pré-jogo" : e.phase === "penaltis" ? "Pen." : e.phase === "pos_jogo" ? "Pós-jogo" : matchMinute(e.seconds, e.period, reset);

export const eventNumbers = (match) =>
  Object.fromEntries(
    [...match.events]
      .sort((a, b) => a.period - b.period || a.seconds - b.seconds || a.created_at.localeCompare(b.created_at))
      .map((e, i) => [e.id, i + 1])
  );

export const PITCH_W = 105;
export const PITCH_H = 68;
export const ZONE_COLS = 6;
export const ZONE_ROWS = ["A", "B", "C"];

export const TECH_AREAS = [
  { zone: "Área Téc.", side: "home", x: 34, y: 69.2, w: 14, h: 4.3 },
  { zone: "Área Téc.", side: "away", x: 57, y: 69.2, w: 14, h: 4.3 },
];
export const TECH_MARGIN = 6;

export const techAt = (x, y) => TECH_AREAS.find((a) => x >= a.x && x <= a.x + a.w && y >= a.y - 0.6 && y <= a.y + a.h + 0.6);

export const zoneFor = (x, y) => {
  const ta = techAt(x, y);
  if (ta) return ta.zone;
  if (y > PITCH_H + 0.3) return null;
  const c = Math.min(ZONE_COLS - 1, Math.floor(x / (PITCH_W / ZONE_COLS)));
  const r = Math.min(ZONE_ROWS.length - 1, Math.floor(y / (PITCH_H / ZONE_ROWS.length)));
  return `${ZONE_ROWS[r]}${c + 1}`;
};

export const targetLabel = (ev) => {
  if (ev.type === "substituicao") return `Sai Nº ${ev.target} · Entra Nº ${ev.player_in}${ev.halftime ? " · Intervalo" : ev.opportunity ? ` · Oportunidade ${ev.opportunity}` : ""}`;
  if (!ev.target) return "—";
  return ev.target_type === "player" ? `Nº ${ev.target}` : ev.target;
};

export const teamName = (match, team) => (team ? match?.[team]?.name : "—");

const subsOf = (match, side) =>
  match.events.filter((e) => e.type === "substituicao" && e.team === side).sort((a, b) => a.period - b.period || a.seconds - b.seconds);

export const AUTO_RED = "Vermelho automático (2º amarelo)";
export const linkedCards = (match, ev) =>
  ev.type === "vermelho" && ev.note === AUTO_RED
    ? match.events.filter((e) => e.type === "amarelo" && e.team === ev.team && e.target === ev.target && e.seconds === ev.seconds && e.period === ev.period)
    : ev.type === "amarelo"
      ? match.events.filter((e) => e.note === AUTO_RED && e.team === ev.team && e.target === ev.target && e.seconds === ev.seconds && e.period === ev.period)
      : [];

export const sentOff = (match, side, kind = "player") =>
  new Set(match.events.filter((e) => e.type === "vermelho" && e.team === side && e.target_type === kind && e.target).map((e) => e.target));

export const onField = (match, side) => {
  const set = new Set(match[side].players.filter((p) => p.starter).map((p) => String(p.number)));
  subsOf(match, side).forEach((e) => { set.delete(e.target); set.add(e.player_in); });
  sentOff(match, side).forEach((n) => set.delete(n));
  return set;
};

export const subbedOut = (match, side) => new Set(subsOf(match, side).map((e) => e.target));

export const OPPORTUNITIES = [1, 2, 3, 4, 5];
export const maxOpportunities = (m) => (isExtraTime(m) ? 6 : 5);
export const opportunitiesFor = (m) => Array.from({ length: maxOpportunities(m) }, (_, i) => i + 1);
export const usedOpportunities = (match, side) => new Set(subsOf(match, side).map((e) => e.opportunity).filter(Boolean));

const other = { home: "away", away: "home" };
export const score = (match, side) =>
  match.events.filter((e) => (e.type === "golo" && e.team === side) || (e.type === "autogolo" && e.team === other[side])).length;

export const priorYellows = (match, t) =>
  t.target ? match.events.filter((e) => e.type === "amarelo" && e.team === t.team && e.target_type === t.target_type && e.target === t.target).length : 0;

export const shootoutScore = (m, side) => (m.shootout || []).filter((k) => k.team === side && k.scored).length;
export const scoreText = (m, sep = " – ") =>
  `${score(m, "home")}${sep}${score(m, "away")}${m.shootout?.length ? ` (${shootoutScore(m, "home")}-${shootoutScore(m, "away")} g.p.)` : ""}`;
